import { translate } from "app/filters/i18nFilter";
import { KEYWORDS_TOOLTIP } from "app/pages/activation/components/Topics/Topic/texts";

import type { ModalConfig, NumOrStr } from "./types";
import { ModalFlow } from "./types";

const MODAL_WIDTH = 700;
const SMALL_MODAL_WIDTH = 464;
const MODAL_HEIGHT = 650;
const SMALL_MODAL_HEIGHT = 250;
export const TOPICS_CONTAINER_HEIGHT = 336;
export const LOADER_HEIGHT = 72;
export const LOADER_WIDTH = 632;
export const LOADERS_COUNT = 3;

const DELETE_SHARED_WIDTH = 400;
const DELETE_SHARED_HEIGHT = 197;

export const MAX_TOPICS = 20;
export const MAX_TOPICS_FOR_ONE_ADD = 10;

const toPx = (v: NumOrStr) => (typeof v === "number" ? `${v}px` : v);

const SIZE = {
    small: {
        width: SMALL_MODAL_WIDTH,
        minHeight: SMALL_MODAL_HEIGHT / 2,
        maxHeight: "auto",
    },
    regular: {
        width: MODAL_WIDTH,
        minHeight: MODAL_HEIGHT / 2,
        maxHeight: "auto",
    },
    deleteShared: {
        width: DELETE_SHARED_WIDTH,
        minHeight: DELETE_SHARED_HEIGHT / 2,
        maxHeight: "auto",
    },
    collision: {
        width: DELETE_SHARED_WIDTH,
        minHeight: DELETE_SHARED_HEIGHT,
        maxHeight: 600,
    },
} as const;

const FLOW_TO_SIZE: Record<ModalFlow, keyof typeof SIZE> = {
    [ModalFlow.Add]: "regular",
    [ModalFlow.Advanced]: "regular",
    [ModalFlow.Edit]: "regular",
    [ModalFlow.Delete]: "small",
    [ModalFlow.DeleteShared]: "deleteShared",
    [ModalFlow.Collision]: "collision",
};

const BASE_CONTENT: ModalConfig["content"] = {
    padding: 0,
    border: "unset",
    width: toPx(SIZE.regular.width),
    minHeight: toPx(SIZE.regular.minHeight),
};

export const getModalConfig = (flow: ModalFlow, overrides?: Partial<ModalConfig["content"]>): ModalConfig => {
    const sizeKey = FLOW_TO_SIZE[flow] ?? "regular";
    const size = SIZE[sizeKey];

    const content: ModalConfig["content"] = {
        ...BASE_CONTENT,
        width: toPx(size.width),
        minHeight: size?.minHeight ? toPx(size.minHeight) : "auto",
        maxHeight: size?.maxHeight ? toPx(size.maxHeight) : "auto",
        ...overrides,
    };

    return { content };
};

export const getAutocompleteKeyWordsProps = (disabled: boolean) => ({
    placeholder: translate(KEYWORDS_TOOLTIP),
    autoSelectInputOnFocus: true,
    resetValueOnSelect: true,
    reFocusOnSelect: true,
    disabled,
});
